<div class="form-floating-icon">
  <input
    [attr.aria-describedby]="ariaDescribedBy || null"
    [attr.aria-invalid]="!isValid"
    [attr.avoidCopyPaste]="inputElem.avoidCopyPaste || false"
    [attr.data-test]="'form-input-' + inputElem.name"
    [attr.disabled]="inputElem.isDisabled ? '' : null"
    [attr.readonly]="isLoading || inputElem.isReadonly ? 'true' : null"
    [attr.id]="inputElem.name"
    [attr.name]="inputElem.name"
    [attr.placeholder]="inputElem.placeholder | translate"
    [formControl]="parentForm.controls[inputElem.name]"
    [mweBlockPasteEvent]="inputElem.avoidCopyPaste"
    [mweInputKeyDirective]="inputElem.directiveType"
    [ngClass]="{
      'is-invalid':
        inputElem.datepickerConfig.readonly === false &&
        parentForm.controls[inputElem.name].errors &&
        !parentForm.controls[inputElem.name].pristine,
      'bg-transparent': inputElem.datepickerConfig.readonly,
    }"
    class="form-control datetimepicker-input"
    hidden
    type="text"
  />
  <button
    (click)="openDatepicker(inputElem.datepickerConfig, $event)"
    [attr.aria-label]="'global.datepicker.toggleButton' | translate"
    class="btn btn-clean"
    type="button"
    [attr.disabled]="isLoading ? 'disabled' : null"
  >
    <i class="far fa-calendar-alt"></i>
  </button>
</div>
